
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M153.464 298.417c-11.313-16.805-25.916-31.242-42.915-42.425 16.999-11.184 31.602-25.617 42.915-42.419 11.31 16.802 25.913 31.235 42.909 42.419-16.996 11.183-31.6 25.62-42.909 42.425zm332.532-67.722H280.912c-56.168 0-101.859-45.169-101.859-100.695h-51.172c0 55.62-45.614 100.714-101.881 100.714v50.568c56.267 0 101.881 45.094 101.881 100.718h51.172c0-55.526 45.691-100.718 101.859-100.718h31.183v54.42h51.172v-54.42h34.58V382h51.168v-64.162c0-20.189 16.556-36.556 36.981-36.556z","fill":"#c5ab80","fill-rule":"evenodd"}})])
          )
        }
      }
    